module.exports = __webpack_public_path__ + "static/img/logo.270ff1da.png";